<!--
 * @Description  : 知识库管理
 * @Author       : zcc
 * @Date         : 2025-04-23 14:36:59
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-23 14:41:44
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\home.vue
-->
<template>
  <transition name="fade" mode="out-in">
    <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Invoice-home",
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState("tags", {
      cachedViews: state => state.cacheTags
    }),
    key() {
      return this.$route.name;
    }
  }
};
</script>

<style scoped lang="less"></style>
